<template>
  <div class="change_mobile_box">
    <div class="change_mobile" @click="changeMobileDialog">使用其他手机号</div>
    <!-- 更换手机号弹窗 -->
    <el-dialog :visible.sync="dialogVisible" title="新手机号码" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
        <el-form-item
          label="手机号："
          prop="mobile"
          :rules="[{required: true, message: '请填写手机号', trigger: 'blur'}]"
        >
          <el-input v-model="form.mobile" style="width:200px;"></el-input>
          <!-- 图片验证码对话框 -->
          <div class="yz_btn" v-show="!downcount" @click="sendCode">发送验证码</div>
          <div class="yz_btn" v-show="downcount">{{times}}s</div>
          <yzm_alert :yzmObj="yzmObj" v-on:setDwoncountSwitch="downcoutStart"></yzm_alert>
        </el-form-item>
        <el-form-item
          label="手机验证码："
          prop="mobileCode"
          :rules="[{required: true, message: '手机验证码不能为空', trigger: 'blur'}]"
        >
          <el-input v-model="form.mobileCode" style="width:200px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import yzm_alert from "@/components/yzm_alert/yzm_alert";
export default {
  components: {
    yzm_alert
  },
  data() {
    return {
      form: {
        mobile: "",
        mobileCode: ""
      },
      dialogVisible: false,
      rules: {},
      yzmObj: {
        mobile: null,
        dialogVisible: null,
        type: "MobileCodeTypeAuthenticationInnovationVouchers"
      },
      downcount: false, //倒计时切换开关
      times: 60, //倒计时时间
      timer: null //定时器
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.changeMobile();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeMobileDialog() {
      this.dialogVisible = true;
    },
    /**新增新的手机号 */
    changeMobile() {
      if (!/^1[0-9]{10,10}$/.test(this.form.mobile)) {
          this.$message("手机号格式不正确！");
        return;
      }
      this.api.checkMobile(this.form).then(res => {
        if (res.error.err_code !== 0) return;
        this.dialogVisible = false;
        this.$emit("receiveMobile", {
          mobile: this.form.mobile
        });
        this.$message({
          type: "success",
          message: "更换手机号成功!"
        });
      });
    },
    /**发送验证码 */
    sendCode() {
      if (!this.downcount) {
        if (!/^1[0-9]{10,10}$/.test(this.form.mobile)) {
          this.$message("手机号格式不正确！");
          return;
        }
        this.yzmObj.mobile = this.form.mobile;
        this.yzmObj.dialogVisible = true;
      } else {
        this.$message("请不要重复点击");
      }
    },
    /**
     * 发送验证码切换倒计时
     * */
    downcoutStart(data) {
      console.log(data);
      if (data) {
        this.downcount = true;
        clearInterval(this.timer);
        this.times = 60;
        this.timer = setInterval(() => {
          this.times--;
          if (this.times === 0) {
            clearInterval(this.timer);
            this.timer = false;
            this.downcount = false;
          }
        }, 1000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.change_mobile_box {
  .change_mobile {
    display: inline-block;
    cursor: pointer;
    color: #0075ff;
  }

  // .change_mobile:hover {
  //   color: #ff8f63;
  // }
  .yz_btn {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    width: 110px;
    text-align: center;
    border: 1px solid #f08300;
    border-radius: 4px;
    cursor: pointer;
    vertical-align: middle;
    color: #f08300;
    margin-left: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>